// customDomainsHooks.ts
import { UseMutationOptions } from "@tanstack/react-query";
import { useMutationApi, useQueryApi } from "api/hooks.ts";
import { customDomainsApi } from "api/TenantSlug/CustomDomain/api";
import { AxiosError } from "axios";
import { ApiErrorResponse } from "types/models.ts";

import GetCustomDomainsResponse = App.Http.Responses.CustomDomain.GetCustomDomainsResponse;
import GetCustomDomainResponse = App.Http.Responses.CustomDomain.GetCustomDomainResponse;
import StoreCustomDomainRequest = App.Http.Requests.CustomDomain.StoreCustomDomainRequest;
import UpdateCustomDomainRequest = App.Http.Requests.CustomDomain.UpdateCustomDomainRequest;
import GetCustomDomainsRequest = App.Http.Requests.CustomDomain.GetCustomDomainsRequest;
import GetCustomDomainRequest = App.Http.Requests.CustomDomain.GetCustomDomainRequest;

export const useGetCustomDomainsQuery = (request: GetCustomDomainsRequest, options = {}) => {
    return useQueryApi<GetCustomDomainsResponse>({
        queryKey: ["getCustomDomains", request],
        queryFn: () => customDomainsApi.index(request),
        ...options,
    });
};

export const useGetCustomDomainQuery = (domainId: string, request?: GetCustomDomainRequest, options = {}) => {
    return useQueryApi<GetCustomDomainResponse>({
        queryKey: ["getCustomDomain", domainId],
        queryFn: () => customDomainsApi.show(domainId, request),
        ...options,
    });
};

export const useStoreCustomDomainMutation = (
    options: UseMutationOptions<GetCustomDomainResponse, AxiosError<ApiErrorResponse>, StoreCustomDomainRequest> = {}
) => {
    return useMutationApi<GetCustomDomainResponse, StoreCustomDomainRequest>({
        mutationKey: ["storeCustomDomain"],
        mutationFn: (request: StoreCustomDomainRequest) => customDomainsApi.store(request),
        ...options,
    });
};

export const useUpdateCustomDomainMutation = (
    options: UseMutationOptions<
        GetCustomDomainResponse,
        AxiosError<ApiErrorResponse>,
        { domainId: string; request: UpdateCustomDomainRequest }
    > = {}
) => {
    return useMutationApi<GetCustomDomainResponse, { domainId: string; request: UpdateCustomDomainRequest }>({
        mutationKey: ["updateCustomDomain"],
        mutationFn: ({ domainId, request }) => customDomainsApi.update(domainId, request),
        ...options,
    });
};

export const useDestroyCustomDomainMutation = (
    options: UseMutationOptions<null, AxiosError<ApiErrorResponse>, string> = {}
) => {
    return useMutationApi<null, string>({
        mutationKey: ["destroyCustomDomain"],
        mutationFn: (domainId: string) => customDomainsApi.destroy(domainId),
        ...options,
    });
};
